import { render, staticRenderFns } from "./StatisticCardHorizontal.vue?vue&type=template&id=0492a66e&"
import script from "./StatisticCardHorizontal.vue?vue&type=script&lang=js&"
export * from "./StatisticCardHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0492a66e')) {
      api.createRecord('0492a66e', component.options)
    } else {
      api.reload('0492a66e', component.options)
    }
    module.hot.accept("./StatisticCardHorizontal.vue?vue&type=template&id=0492a66e&", function () {
      api.rerender('0492a66e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/components/statistics-cards/StatisticCardHorizontal.vue"
export default component.exports